import { computed, signal } from "@angular/core";
import { Injectable } from "@angular/core"; // Importing Injectable decorator from Angular core  
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class LoaderService {
  loadingSubject = new Subject<any>(); // Subject to emit loading state changes
  loading$ = this.loadingSubject.asObservable(); // Observable to subscribe to loading state changes

  constructor() { }

  public show(loaderId: string): void {
    this.loadingSubject.next({ loading: true, loaderId }); // Emit true to indicate loading has started
  }

  public hide(loaderId: string): void {
    this.loadingSubject.next({ loading: false, loaderId }); // Emit true to indicate loading has started
  }

  public isLoading() {
    return this.loadingSubject.asObservable(); // Return the observable to subscribe to loading state changes
  }

}